export const BUSINESS_DOMAINS = {
    cuba: 'intranet.cubaspa.com.pe',
    test: 'intranet.cubaspa.com.pe',
    kuntesoluciones: 'intranet.kuntespasoluciones.innout.cloud',
    // Empresa de pruebas: mismo tenant demo que usa el BFF para idSede 999.
    pruebita: 'pruebita.intranet.innout.cloud'
}

export const DEFAULT_BUSINESS = 'test'
